import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoginService } from './../../services/login.service';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { AccountInfo, LocalStorageUtil } from 'src/app/util/local-storage-util';
import { SignatureService } from 'src/app/services/signature.service';
import { environment } from 'src/environments/environment';
import { LoginV2Service } from 'src/app/services/login-v2.service';
import { mergeMap, switchMap, tap } from 'rxjs/operators';
import { AccountV2Service } from 'src/app/services/account-v2.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  isLoading: boolean = false;

  missingPassword: string = '/forgot-password';
  hidePassword = true;

  private subs = new Subscription();

  constructor(
    private fb: FormBuilder,
    private snack: MatSnackBar,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private loginService: LoginService,
    private signatureService: SignatureService,
    private loginV2Service: LoginV2Service,
    private accountV2Service: AccountV2Service
  ) {}

  buttonDisabled = false;

  readonly enableIdpLogin = Boolean(environment.enableIdpLogin);
  useIdp = false;

  public ngOnInit() {
    this.loginForm = this.fb.group({
      user: [null, [Validators.required]],
      password: [null, [Validators.required]],
    });
  }

  // checkToken() {
  //   this.isLoading = true;
  //   this.loginService.showMessage('Validando o link, aguarde', 6000);
  //   this.loginService.checkToken(this.token).subscribe(
  //     (res) => {
  //       if (res.status) {
  //         this.router.navigate([`/complete-registration/${this.token}`]);
  //       } else {
  //         this.loginService.showMessage('Erro no validar link', 6000);
  //         this.router.navigate([`/login`]);
  //       }
  //     },
  //     (error) => {
  //       this.loginService.showMessage('Erro no validar link', 6000);
  //       this.router.navigate([`/login`]);
  //     }
  //   );
  // }

  public login() {
    if (this.loginForm.invalid) {
      this.snack.open('Preencha os campos corretamente', 'ok', {
        duration: 3000,
      });
      return;
    }

    this.isLoading = true;

    const formValue = this.loginForm.getRawValue();
    const signin$ = this.useIdp
      ? this.loginV2Service.signinWithIdp(formValue)
      : this.loginV2Service.signin(formValue);

    this.subs.add(
      signin$
        .pipe(
          tap((res) => {
            LocalStorageUtil.setToken(res.accessToken);
            LocalStorageUtil.setAuthProvider(this.useIdp ? 'keycloak' : 'legacy');
          }),
          switchMap(() => this.accountV2Service.getProfile())
        )
        .subscribe({
          next: (accountInfoResponse) => {
            const accountInfo: AccountInfo = {
              accountId: accountInfoResponse.account.id,
              accountName: accountInfoResponse.account.name,

              userId: accountInfoResponse.user.id,
              userName: accountInfoResponse.user.name,
              admin: accountInfoResponse.user.function === 'Administrador',
              superAdmin: Boolean(accountInfoResponse.user.administrativeGroup?.isSuperAdmin),
              administrativeRole: accountInfoResponse.user.administrativeGroup?.role ?? null,
              financeiroRole:
                accountInfoResponse.user.administrativeGroup?.role === 'FINANCEIRO' ||
                (Boolean(accountInfoResponse.user.administrativeGroup?.isSuperAdmin) &&
                  accountInfoResponse.user.administrativeGroup?.role !== 'OPERACIONAL'),
              userEmail: accountInfoResponse.user.email,

              createdAt: Math.floor(Date.now() / 1000),
            };

            this.loginService.startIntercom(accountInfo);

            this.signatureService.getLoginRedirectTargetV2().subscribe(
              ({ destination }) => {
                LocalStorageUtil.setAccountInfo(accountInfo);
                const route = destination === 'v2/dashboard' ? '/v2/dashboard' : `/${destination}`;
                this.router.navigate([route]);
                this.isLoading = false;
              },
              () => {
                this.isLoading = false;
                this.router.navigate(['/signature']);
              }
            );
          },
          error: (error) => {
            this.snack.open('Usuário ou senha incorretos', 'ok', {
              duration: 3000,
            });
            this.isLoading = false;
          },
        })
    );
  }

  public goToRegister() {
    this.router.navigate(['/register']);
  }

  public ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
